import {
  inputRules,
  wrappingInputRule,
  smartQuotes,
  emDash,
  ellipsis,
} from 'prosemirror-inputrules';

import schema from './schema';

export default inputRules({
  rules: [
    ...smartQuotes,
    ellipsis,
    emDash,

    // 1. ordered list
    wrappingInputRule(
      /^(\d+)\.\s$/,
      schema.nodes.ordered_list,
      match => ({ order: +match[1] }),
      (match, node) => node.childCount + node.attrs.order === +match[1],
    ),

    // * bullet list
    wrappingInputRule(/^\s*([-+*])\s$/, schema.nodes.bullet_list),
  ],
});
